import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Table, CardBox, EmptyState, Page } from "../../components";
import { retrieve } from "../../actions/organization-actions";
import { push } from "../../actions/nav-actions";
import { testRegex } from "../../utils";
import constants from "../../defaults/constants";
import { CSVLink } from "react-csv";
import { getResourceReport } from "../../api";
import Loader from "../../components/Loader";

const ResourceReport = ({ user, retrieve, organizations }) => {
  const [query, setQuery] = useState("");
  const [resourceData, setResourceData] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    retrieve(user.token);
    getReport();
  }, []);

  const getReport = () => {
    const start =
      startDate && startDate !== undefined
        ? new Date(startDate).toLocaleDateString()
        : null;
    const end =
      endDate && endDate !== undefined
        ? new Date(endDate).toLocaleDateString()
        : null;
    setLoading(true);
    getResourceReport(user.token, start, end)
      .then((res) => {
        const formattedData = res.map((item) => ({
          ...item,
          dateSignedUp: new Date(item.created_at).toLocaleDateString(),
        }));
        setResourceData(formattedData);
        console.log(formattedData);
        //  clean up
        setLoading(false);
        return () => {
          setResourceData([]);
        };
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const renderEmpty = () => <Loader />;

  const renderChild = () => [
    { Header: "Title", accessor: "title" },
    { Header: "Author", accessor: "author" },
    { Header: "Publisher", accessor: "publisher" },
    { Header: "Key", accessor: "key" },
    { Header: "Type", accessor: "type" },
    { Header: "URL", accessor: "url" },
    { Header: "Date Added", accessor: "dateSignedUp" },
  ];

  const handleDownload = () => {
    const data = resourceData.map(
      ({ _id, title, author, publisher, key, type, url, created_at }) => ({
        _id,
        title,
        author,
        publisher,
        key,
        type,
        url,
        created_at,
      })
    );
    return data;
  };

  const results = resourceData.filter((i) => testRegex(i.title, query));

  const csvHeaders = [
    { label: "ID", key: "_id" },
    { label: "Title", key: "title" },
    { label: "Author", key: "author" },
    { label: "Publisher", key: "publisher" },
    { label: "Key", key: "key" },
    { label: "Type", key: "type" },
    { label: "URL", key: "url" },
    { label: "Date Added", key: "created_at" },
  ];

  return (
    <Page title={user.is_admin ? "Master Library Report" : "Master Library "}>
      {user && user.is_admin && (
        <div style={{ display: "flex" }}>
          <div className="form-group">
            <label>Start Date</label>
            <input
              type="date"
              className="form-control"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>End Date</label>
            <input
              type="date"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

          <div className="form-group">
            {/* A filter button */}
            <button
              className="btn btn-info"
              style={{ marginLeft: 10, marginTop: 33 }}
              onClick={getReport}
            >
              {"Filter"}
            </button>
          </div>
        </div>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          //
        }}
      >
        {/* Search box here */}
        <input
          type="text"
          className="form-control"
          placeholder="Search..."
          style={{ width: "25%", marginBottom: 33 }}
          onChange={(e) => setQuery(e.target.value)}
        />
        {user && user.is_admin && (
          <CSVLink
            data={handleDownload()}
            headers={csvHeaders}
            filename={`resources-report-${new Date().toLocaleDateString()}.csv`}
            className="btn btn-info btn-block"
            style={{ width: "20%", marginBottom: 33 }}
          >
            Download Resources
          </CSVLink>
        )}
      </div>
      <CardBox>
        <Table
          id="survey"
          renderEmpty={renderEmpty}
          columns={renderChild()}
          data={results}
        />
      </CardBox>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  user: state.authReducer.user,
  organizations: state.organizations,
});

const mapDispatchToProps = (dispatch) => ({
  retrieve(token) {
    dispatch(retrieve(token));
  },
  push(routeName) {
    dispatch(push(routeName));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ResourceReport);



// WEBPACK FOOTER //
// ./src/routers/Reports/ResourceReports.js